import React, { useRef, useEffect } from 'react';
import InputStyles from './Input.styled';

function Input({
  title,
  name,
  type,
  autoComplete,
  pattern,
  autoFocus,
  required,
  className,
  onChange,
  onFocus,
  hasError,
  getInputProps,
  onInput
}) {
  const elem = useRef();

  useEffect(() => {
    if (!elem.current || !onInput) {
      return undefined;
    }
    elem.current.addEventListener('input', onInput);

    return () => {
      if (elem.current && onInput) {
        elem.current.removeEventListener('input', onInput);
      }
    };
  }, []);
  return (
    <InputStyles className={className || ''}>
      <input
        ref={elem}
        className={hasError ? `${name}-input has-error` : `${name}-input`}
        name={name}
        type={type || 'text'}
        placeholder={title || ''}
        autoComplete={autoComplete}
        autoFocus={autoFocus && autoFocus}
        required={required && required}
        onChange={onChange}
        onFocus={onFocus}
        pattern={pattern}
        {...(getInputProps ? getInputProps() : [])}
      />
    </InputStyles>
  );
}

export default Input;
